import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { User } from 'src/app/core/models/auth.models';
import { AuthenticationService } from 'src/app/core/service/auth.service';
import { BoardServiceService } from '../../services/board-service.service';
import { BoardMainScreenService } from '../board-main-screen/board-main-screen.service';
import { filter, first, takeUntil } from 'rxjs/operators';
import { UtilsService } from 'src/app/core/service/utils.service';
import moment from 'moment';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { Location } from '@angular/common';


@Component({
  selector: 'app-times-info-top-bar',
  templateUrl: './times-info-top-bar.component.html',
  styleUrls: ['./times-info-top-bar.component.scss']
})
export class TimesInfoTopBarComponent implements OnInit {
  destroy$: Subject<any> = new Subject<any>();
  loading: boolean = false;
  loggedInUser: User | null = null;

  /*time tracking */
  trackingTotal: string = '';
  trackingTotalUpdate: string = '00:00:00';
  trackingTotalRaw: number;
  trackingTotalRawBeginWith: number;
  trackingTotalInterval: any = null;
  running: boolean = false;

  showModal: boolean = true;

  lastTrackStart: Date | null = null;

  tasksList: any = [];

  constructor(
    public translateService: TranslateService,
    private authService: AuthenticationService,
    private boardService: BoardServiceService,
    public boardMainScreen: BoardMainScreenService,
    public utilSrv: UtilsService,
    protected router: Router,
    private location: Location
  ) {
    this.loggedInUser = this.authService.currentUser;
  }

  ngOnInit(): void {


    this.boardMainScreen.trackingRunning.pipe(
      takeUntil(this.destroy$),
    ).subscribe((value: any) => {
      if (value?.status == true) {

        if (this.tasksList.length > 0 && this.tasksList[0] && value?.id) {

          if (this.tasksList[0].id != value?.id)
            this.getTasksList();
        }

      }
    })
  }
  ngOnDestroy() {
    // this.destroy$.next(0);
    // this.destroy$.unsubscribe();
  }

  loadTaskInfo() {
    this.getTasksList();
  }

  getTasksList() {
    this.loading = true;
    this.boardService.getLastStartedTasks().pipe(first()).subscribe((response) => {
      this.tasksList = response.data;
      this.loading = false;
    }, (error: any) => {
      this.utilSrv.toast(`Tasks: ${error}`, 'error', false);
      this.tasksList = [];
      this.loading = false;
    });

  }







}
